import { claimConstants } from '../constants'
import { claimService, rewardsService } from '../../services'
import { request, success, failure } from './helper'
import { getCaptchaToken } from '../../utilities/googleCaptcha.util'

function claimCouponCode(couponCode, webGL) {
  return async dispatch => {
    dispatch(request(claimConstants.CLAIM_COUPON_REQUEST, { couponCode }))
    try {
      await claimService.claimCouponValidation(couponCode)
      const captchaToken = await getCaptchaToken('coupon')
      const response = await claimService.claimCouponCode(couponCode, webGL, captchaToken)
      const { proofOfPurchase, claimStep } = response
      if (proofOfPurchase) {
        dispatch(request(claimConstants.CLAIM_COUPON_PROOF_REQUIRED, { proofOfPurchase }))
      } else {
        dispatch(success(claimConstants.CLAIM_COUPON_SUCCESS, { claimStep }))
      }
    } catch (error) {
      // No longer using form errors. Use modal
      // reduxFormFailure(dispatch, claimConstants.CLAIM_COUPON_FAILURE, error)
      dispatch(failure(claimConstants.CLAIM_COUPON_FAILURE, error))
    }
  }
}

function claimTokenCode(tokenCode, webGL) {
  return async dispatch => {
    dispatch(request(claimConstants.CLAIM_TOKEN_REQUEST, { tokenCode }))
    try {
      await claimService.claimTokenValidation(tokenCode)
      const captchaToken = await getCaptchaToken('token')
      const response = await claimService.claimTokenCode(tokenCode, webGL, captchaToken)
      const couponCode = await claimService.getCouponKeyWithTokenKey(tokenCode)
      const { proofOfPurchase, claimStep } = response
      if (proofOfPurchase) {
        dispatch(request(claimConstants.CLAIM_TOKEN_PROOF_REQUIRED, { proofOfPurchase }))
      } else {
        dispatch(success(claimConstants.CLAIM_TOKEN_SUCCESS, { claimStep, couponCode }))
      }
    } catch (error) {
      // No longer using form errors. Use modal
      // reduxFormFailure(dispatch, claimConstants.CLAIM_TOKEN_FAILURE, error)
      dispatch(failure(claimConstants.CLAIM_TOKEN_FAILURE, error))
    }
  }
}

function selectContent(promotionStepId, content) {
  return dispatch => {
    try {
      dispatch(request(claimConstants.ADD_SELECTED_CONTENT, { promotionStepId, content }))
    } catch (err) {
      dispatch(failure(claimConstants.ADD_SELECTED_CONTENT_FAILURE))
    }
  }
}

function deselectContent(promotionStepId, contentId) {
  return dispatch => {
    dispatch(request(claimConstants.REMOVE_SELECTED_CONTENT, { promotionStepId, contentId }))
  }
}

function getPromotion(promotionId) {
  return async dispatch => {
    dispatch(request(claimConstants.GET_PROMOTION_REQUEST))
    try {
      const promotion = await claimService.getPromotion(promotionId)
      dispatch(success(claimConstants.GET_PROMOTION_SUCCESS, { promotion }))
    } catch (err) {
      dispatch(failure(claimConstants.GET_PROMOTION_FAILURE))
    }
  }
}

function getSurveyByCouponCode(couponCode) {
  return async dispatch => {
    try {
      const survey = await claimService.getSurveyByCouponCode(couponCode)
      dispatch(success(claimConstants.GET_SURVEY_SUCCESS, { survey }))
    } catch (err) {
      dispatch(failure(claimConstants.GET_SURVEY_FAILURE))
    }
  }
}

function getPromotionByCouponCode(couponCode) {
  return async dispatch => {
    try {
      const promotion = await claimService.getPromotionByCouponCode(couponCode)
      // Set promotion
      dispatch(success(claimConstants.GET_PROMOTION_SUCCESS, { promotion }))
      // Set active promotion step
    } catch (err) {
      dispatch(failure(claimConstants.GET_PROMOTION_FAILURE))
    }
  }
}

function setActivePromotionStep(promotionStepId) {
  return dispatch => {
    dispatch(request(claimConstants.SET_ACTIVE_PROMOTION_STEP, { promotionStepId }))
  }
}

function goPreviousClaimState() {
  return dispatch => {
    dispatch(request(claimConstants.PREVIOUS_CLAIM_STATE))
  }
}

function goNextClaimState() {
  return dispatch => {
    dispatch(request(claimConstants.NEXT_CLAIM_STATE))
  }
}

function clearRedeemState() {
  return dispatch => {
    dispatch(request(claimConstants.CLEAR_REDEEM_STATE))
  }
}

function toggleConfirm() {
  return dispatch => {
    dispatch(request(claimConstants.TOGGLE_CONFIRM))
  }
}

function clearProofOfPurchase() {
  return dispatch => {
    dispatch(request(claimConstants.CLEAR_PROOF_OF_PURCHASE))
  }
}

function redeemContent(couponKey, tokenKey, selectedContentList, webGL, survey) {
  return async dispatch => {
    const payload = {
      couponKey,
      tokenKey,
      redemptions: [],
      survey,
      // COMMENTED OUT UNTIL REDEMPTION KEY ASSIGNMENT BUG IS SOLVED
      // redemptionId: null
    }
    selectedContentList.forEach(promotion => {
      promotion.selectedContent.forEach(content => {
        payload.redemptions.push(content)
      })
    })
    try {
      const content = await claimService.redeemContent(payload, webGL)
      dispatch(request(claimConstants.CLAIM_SUCCESS, { redemptions: content.redemptionsResponse }))
      // COMMENTED OUT UNTIL REDEMPTION KEY ASSIGNMENT BUG IS SOLVED
      // dispatch(request(claimConstants.CLAIM_SUCCESS, { redemptions: content.redemptionsResponse, redemptionId: content.redemptionId }))
    } catch (err) {
      if (err && String(err.status).match(/4\d\d/g)) {
        dispatch(request(claimConstants.CLAIM_FAILURE))
      }
    }
  }
}

function setSelectState(coupon, redemptionId) {
  return dispatch =>
    claimService.checkCompletedSurvey(redemptionId).then(async surveyCheck => {
      const surveyCompleteCheck = dispatch(
        request(claimConstants.CHECK_SURVEY_COMPLETE_SUCCESS, { surveyCheck })
      )
      await Promise.resolve(surveyCompleteCheck)
      dispatch(request(claimConstants.SET_SELECT_STATE, { coupon }))
    })
}

function emailRedemption(redemptionId) {
  return () => claimService.emailRedemption(redemptionId)
}

function updateSurveyFieldData(response, type, question) {
  return dispatch => {
    dispatch(request(claimConstants.UPDATE_SURVEY_FIELD_DATA_SUCCESS, { response, type, question }))
  }
}

function updateSurveyFieldResponse(response, question) {
  return dispatch => {
    dispatch(request(claimConstants.UPDATE_SURVEY_FIELD_RESPONSE, { response, question }))
  }
}

function logRevealKey(redemptionId, couponCode, contentId, partnerId) {
  const payload = {
    redemptionId,
    couponCode,
    contentId,
    partnerId,
  }
  return async dispatch => {
    try {
      await rewardsService.logRevealKey(payload)
      dispatch(request(claimConstants.LOG_REVEAL_KEY_SUCCESS))
    } catch (err) {
      dispatch(request(claimConstants.LOG_REVEAL_KEY_FAILURE))
    }
  }
}

export default {
  claimCouponCode,
  claimTokenCode,
  selectContent,
  deselectContent,
  getPromotion,
  getPromotionByCouponCode,
  setActivePromotionStep,
  goPreviousClaimState,
  goNextClaimState,
  redeemContent,
  clearRedeemState,
  toggleConfirm,
  clearProofOfPurchase,
  setSelectState,
  emailRedemption,
  getSurveyByCouponCode,
  updateSurveyFieldData,
  updateSurveyFieldResponse,
  logRevealKey,
}
